import React from "react";
import { Button } from "reactstrap";
import { ReactComponent as ChevronUp } from "../../images/icons/chevron-up.svg";
import "./styles.scss";

const TopFloatButton = ({ onClick }) => {
  return (
    <Button color="primary" className="top-float-button" onClick={onClick}>
      <ChevronUp />
      Top
    </Button>
  );
};

export default TopFloatButton;
